import React from 'react';
import PropTypes from 'prop-types';

import { CLIENT_PROFILE_COMPONENT_TYPES, clientProfileRoutes, paymentRoutes } from '@atlas/routing';

import ClientProfileSubRouter from 'components/ClientProfile/ClientProfileSubRouter';

import Deposit from './Deposit/DepositList';
import TransactionHistory from './Transaction/TransactionHistory';
import Withdrawal from './Withdrawal/WithdrawalList';

const { payment } = clientProfileRoutes;

const { deposit, transactionHistory, withdrawal } = paymentRoutes;

const getAvailableRoutes = clientProfilePath => ({
  [CLIENT_PROFILE_COMPONENT_TYPES.PAYMENT_DEPOSIT]: {
    component: Deposit,
    optionalPath: '/:paymentMethod?',
    path: `${clientProfilePath}/${payment}/${deposit}`,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PAYMENT_WITHDRAWAL]: {
    component: Withdrawal,
    optionalPath: '/:paymentMethod?',
    path: `${clientProfilePath}/${payment}/${withdrawal}`,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY_TRANSACTION_HISTORY]: {
    component: TransactionHistory,
    path: `${clientProfilePath}/${payment}/${transactionHistory}`,
  },
});

const PaymentRouter = ({ tabs = [] }) => (
  <ClientProfileSubRouter
    getAvailableRoutes={getAvailableRoutes}
    parentRoute={payment}
    tabs={tabs}
  />
);

PaymentRouter.propTypes = { tabs: PropTypes.array };

export default PaymentRouter;
